import React, { useState } from "react";
import { Outlet, useLocation } from "react-router-dom";
import Sidebar from "../components/Sidebar";
import Header from "../components/Header";
import { Container, Row, Col, Card } from "react-bootstrap";
import CardStats from "../components/CardStats";
import DepartmentChart from "../components/DepartmentChart";
import LeaderboardTable from "../components/LeaderboardTable";
import { FaCalendarAlt } from "react-icons/fa";
import Managerpage from "./Managerpage";

const Dashboard = () => {
  const [isSidebarOpen, setSidebarOpen] = useState(false);

  const {pathname} = useLocation()

  return (
    <div className="d-flex">
      <div className="d-md-block d-none">
        <Sidebar isOpen={isSidebarOpen} onClose={() => setSidebarOpen(false)} />
      </div>

      <div className="flex-grow-1">
        <Header />

        <div className="dashboard-content p-md-4 px-md-5 px-3 py-md-4 py-4 ">
          <Outlet />
        </div>
      </div>
    </div>
  );
};

export default Dashboard;
